module.exports = __webpack_public_path__ + "static/media/search_clinical_trial.fc41eeac.svg";